import { BrowserRouter } from 'react-router-dom'
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { createRoot } from 'react-dom/client'
import reportWebVitals from './reportWebVitals'
import './index.css'
import './core/i18n'
import App from './App'
import { initOptions, keycloak } from './core/keycloak/keycloak'
import { AxiosRequest } from './core/api/axios-request'

const container = document.getElementById('groot')
const root = createRoot(container!)

const eventLogger = (event: unknown, error: unknown) => {
  console.log('onKeycloakEvent', event, error)
}

const tokenLogger = (tokens: any) => {
  console.log('onKeycloakTokens', tokens)
  AxiosRequest.setAccessToken(tokens?.token as string)
}

root.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={initOptions}
    onEvent={eventLogger}
    onTokens={tokenLogger}
    LoadingComponent={<div>Loading ...</div>}
  >
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </ReactKeycloakProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
